/**
 * Business callback: tooltip for the current-ink widgets, rendering the
 * machine name plus formatted ink values (convention section 40).
 */
export function currentInkTooltip(params: unknown): string {
  const list = Array.isArray(params) ? params : [params];
  const lines = list.map((item) => {
    const p = item as {
      name?: string;
      seriesName?: string;
      value?: { data?: unknown } | unknown;
      data?: { value?: number };
    };
    const value =
      typeof p.value === "object" && p.value !== null
        ? (p.value as { value?: number }).value
        : p.value;
    return `${p.seriesName ?? "Ink"}: <strong>${String(value ?? "")}</strong>`;
  });
  return [`<strong>${(list[0] as { name?: string })?.name ?? ""}</strong>`, ...lines].join(
    "<br/>",
  );
}
